import TerminalSnapshotBody from './TerminalSnapshotBody'
import TerminalSnapshotHeader from './TerminalSnapshotHeader'
import TerminalSnapshotWrapper from './TerminalSnapshotWrapper'

export default {
  Body: TerminalSnapshotBody,
  Header: TerminalSnapshotHeader,
  Wrapper: TerminalSnapshotWrapper,
}
